import { Component, ViewEncapsulation, input } from '@angular/core';
import { FaqItemComponent } from '../../molecules/faq-item/faq-item';

export interface FaqItemData {
  question: string;
  answer: string;
}

@Component({
  selector: 'ds-faq-block',
  templateUrl: './faq-block.html',
  styleUrl: './faq-block.scss',
  encapsulation: ViewEncapsulation.None,
  imports: [FaqItemComponent],
})
export class FaqBlockComponent {
  readonly items = input.required<FaqItemData[]>();
}
